const ALLOWED_DOMAINS = [
  "zapier.com",
  "zapier-staging.com",
  "zapier-deployment.com",
  ...(process.env.NODE_ENV === "development" ? ["localhost"] : []),
];

export function isAllowedOrigin(origin: string): boolean {
  try {
    const url = new URL(origin);
    return ALLOWED_DOMAINS.some(
      (domain) => url.hostname === domain || url.hostname.endsWith(`.${domain}`)
    );
  } catch {
    return false;
  }
}
// Only send message if parent origin is allowed
export function sendMessageToParent(message: unknown) {
  if (
    typeof window !== "undefined" &&
    window.parent !== window &&
    isAllowedOrigin(window.parent.origin)
  ) {
    window.parent.postMessage(message, window.parent.origin);
  }
}
